export const multiLevelTLDs = [
	// 🌍 General
	'com.au',
	'net.au',
	'org.au',
	'co.uk',
	'org.uk',
	'gov.uk',
	'ac.uk',
	'com.ng',
	'org.ng',
	'gov.ng',
	'edu.ng',
	'net.ng',
	'co.za',
	'org.za',
	'gov.za',
	'net.za',
	'co.ke',
	'or.ke',
	'ac.ke',
	'go.ke',
	'co.ug',
	'or.ug',
	'ac.ug',
	'go.ug',
	'com.gh',
	'org.gh',
	'gov.gh',
	'edu.gh',
	'com.tz',
	'co.tz',
	'ac.tz',
	'go.tz',
	'com.na',
	'co.na',
	'org.na',
	'com.zm',
	'co.zm',
	'org.zm',
	'com.bw',
	'co.bw',
	'org.bw',

	// 🇺🇸 Americas
	'com.br',
	'org.br',
	'gov.br',
	'edu.br', // Brazil
	'com.ar',
	'org.ar',
	'gov.ar', // Argentina
	'com.mx',
	'org.mx',
	'gob.mx', // Mexico
	'com.co',
	'org.co',
	'gov.co', // Colombia
	'com.ve',
	'net.ve',
	'org.ve', // Venezuela
	'com.cl',
	'org.cl', // Chile
	'com.pe',
	'org.pe',
	'gob.pe', // Peru
	'com.pa',
	'org.pa', // Panama
	'com.gt',
	'org.gt', // Guatemala
	'com.do',
	'org.do', // Dominican Republic
	'com.cu',
	'org.cu', // Cuba
	'com.pr',
	'org.pr', // Puerto Rico
	'com.ca',
	'net.ca', // Canada (not typical multi-level but used in sub-orgs)

	// 🇪🇺 Europe
	'com.fr',
	'asso.fr',
	'gouv.fr', // France
	'com.de', // Germany (rare multi-level usage)
	'com.it',
	'gov.it',
	'edu.it', // Italy
	'com.es',
	'org.es',
	'gob.es', // Spain
	'com.nl', // Netherlands
	'com.be',
	'org.be', // Belgium
	'com.ie',
	'gov.ie', // Ireland
	'com.pl',
	'gov.pl', // Poland
	'com.pt',
	'gov.pt', // Portugal
	'com.se',
	'org.se',
	'gov.se', // Sweden
	'com.no',
	'org.no', // Norway
	'com.dk',
	'gov.dk', // Denmark
	'com.fi',
	'org.fi', // Finland
	'com.ch',
	'org.ch', // Switzerland
	'com.at',
	'org.at', // Austria
	'com.cz',
	'gov.cz', // Czech Republic
];
